
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auction-consultancy",
      function () {
        return require("private-next-pages/auction-consultancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auction-consultancy"])
      });
    }
  